<template>
	<div class="vx-row w-full ml-1">
		<div class="vx-col w-full">
			<div class="vx-row mb-2 w-full">
				<vx-card>
					<div class="vx-row mb-1">
						<div class="vx-col">
							<h4>Bienvenue sur <strong>Rankwell One</strong>.</h4>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-row mb-2" v-if="this.activeUser.role == 2">
				<SocietyContractsCardsTable
					:collaboratorMain="collaboratorMain"
					:contractsUsersInfo="contractsUsersInfo"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import SocietyContractsCardsTable from "@/components/tables/SocietyContractsCardsTable.vue";
import VueCookies from "vue-cookies";

export default {
	name: "Home",
	components: {
		SocietyContractsCardsTable,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			userContracts: [],
			contractsUsersInfo: null,
			collaboratorMain: {
				firstname: "Contact",
				lastname: "Comptabilité",
				status: true,
				user_type: 2,
				phone: "01 80 89 60 80",
				email: "contact@rankwell.fr",
			},
		};
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	created() {
		this.getAllContractsCollaborators();
		// if consultants go to consultants page
		if (this.activeUser.type == 3) {
			this.$router.push({ name: "consultants" });
		} else this.$router.push({ name: "contracts" });
	},
	methods: {
		scrollTo(refName) {
			let element = this.$refs[refName];
			let top = element.offsetTop;

			window.scrollTo(0, top);
		},

		getUserContracts(userId) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "contract/getcu/" + userId)
					.then((result) => {
						// for(let i = 0; i < result.length; i++){

						// }
						this.userContracts = result.data;
						resolve(result.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		getContractCollaborators(contractInfo) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(
						this.apiUrl + "contract/getrankwellinfo/" + contractInfo.contract_id
					)
					.then((result) => {
						let accountManagers = [];
						let commercials = [];
						for (let i = 0; i < result.data.length; i++) {
							if (result.data[i].user_type == 0) {
								commercials.push(result.data[i]);
							} else {
								accountManagers.push(result.data[i]);
							}
						}
						resolve([contractInfo, commercials, accountManagers]);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		getAllContractsCollaborators() {
			return new Promise((resolve) => {
				this.getUserContracts(this.activeUser.id).then((result) => {
					let queries = [];
					for (let i = 0; i < result.length; i++) {
						queries.push(this.getContractCollaborators(result[i]));
					}
					Promise.all(queries).then((queriesResults) => {
						let contractsUsersInfo = {};
						let societyName = "";
						for (let j = queriesResults.length - 1; j >= 0; j--) {
							if (queriesResults[j][0].name != societyName) {
								societyName = queriesResults[j][0].name;
								contractsUsersInfo[societyName] = {
									info: {
										societyId: queriesResults[j][0].society_id,
										societyName: queriesResults[j][0].name,
										commercialContacts: queriesResults[j][1],
										financialContacts: null,
									},
									contracts: [],
								};
							}
							contractsUsersInfo[societyName].contracts.push({
								contractId: queriesResults[j][0].contract_id,
								data: queriesResults[j][2],
							});
						}

						this.contractsUsersInfo = contractsUsersInfo;
						resolve(true);
					});
				});
			});
		},
	},
};
</script>
